import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormattingService {

  constructor() { }

  formatFirebaseError(error: any): string {
    let formattedError = error.message;

    formattedError = formattedError.replace('Firebase: Error (auth/wrong-password).', 'Wrong password');
    formattedError = formattedError.replace('Firebase: Error (auth/user-not-found).', 'User not found');
    formattedError = formattedError.replace('FirebaseError: Firebase: ', '');
    formattedError = formattedError.replace('Firebase: ', '');
    formattedError = formattedError.replace('The user may have been deleted.', '');

    const errorCodeStart = formattedError.indexOf(' (auth/');
    if (errorCodeStart !== -1) {
        formattedError = formattedError.substring(0, errorCodeStart);
    }

    return formattedError;
  }

  /**
  * Remove caracteres inválidos em nomes de arquivo no Windows e limita o tamanho.
  */
  sanitizeFilename(filename: string, maxLength = 100): string {
    // Remove ou substitui caracteres inválidos
    // / \ : ? * " < > | e quebras de linha
    const invalidChars = /[\r\n\\/:\?\*"<>\|]+/g;
    let safe = filename.replace(invalidChars, "_");

    // Opcional: se quiser remover também espaços duplos ou etc, pode incluir
    // safe = safe.replace(/\s{2,}/g, " ");

    // Limita o tamanho
    if (safe.length > maxLength) {
      safe = safe.substring(0, maxLength);
    }

    // Remove possíveis espaços no final
    safe = safe.trim();

    // Se acabar vazio, coloca algo padrão
    if (!safe) {
      safe = "arquivo";
    }

    return safe;
  }

  // Função auxiliar para ler as dimensões do File
  static async getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.naturalWidth, height: img.naturalHeight });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = e.target!.result as string;
      };
      reader.onerror = err => {
        reject(err);
      };
      reader.readAsDataURL(file);
    });
  }
}
